import styled from "@emotion/styled";
import { Card } from "@snapchat/snap-design-system";

export const NoResultsCard = styled(Card)`
    border: none;
`;
